import Api from '../api';

let uri = '/api/ed/contenido';

export const getTipoContenido = (data) => {
    return Api.getInstance().executeQuery(`${uri}/tipo`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getContenidoCurso = (data) => {
    return Api.getInstance().executeQuery(`${uri}/curso`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const adminContenidoCurso = (data) => {
    return Api.getInstance().executeQuery(uri, data)
    .then(res => res) 
    .catch(err => console.log(err));
}
export const deleteContenidoCurso = (data)  => {
    return Api.getInstance().executeDeleteQuery(uri, {data: data})
    .then(res => res)
    .catch(err => console.log(err));
}



